export default "__VITE_ASSET__DLSoR5uC__"